(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $(".owl-carousel").owlCarousel({
    loop:true,
    margin:10,
    nav:false,
    dots:false,
    autoplay:true,
    autoplayTimeout:5000,
    
    items:1
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collage"] && !Shopify.designMode) return;
  try {
    
  // Whole banner clickable script
  $(".collage__item--image").click(function(){
     window.location=$(this).find("a").attr("href"); 
     return false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-cross-sell"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
  function initializeSlick() {
    var $collectionCrossSellGrid = $('.collection-cross-sell__wrapper');

    if (!$collectionCrossSellGrid.hasClass('slick-initialized')) {
      $collectionCrossSellGrid.slick({
        arrows: true,
        slidesToShow: 4, // Always show 4 items
        slidesToScroll: 1,
        autoplay: false,
        infinite: false, // Disable infinite scroll if needed
        mobileFirst: true,
        speed: 300, // Adjust the speed for smoother transitions
        cssEase: 'ease-in-out', // Use smoother easing for slide transition
        touchThreshold: 5, // Lower threshold for faster swipe response
        swipeToSlide: true,
        responsive: [
          {
            breakpoint: 580,
            settings: {
              slidesToShow: 4, // Show 4 items for screens >= 580px
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 375,
            settings: {
              slidesToShow: 4, // Show 4 items for screens >= 375px
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  }

  function checkWidth() {
    var $collectionCrossSellGrid = $('.collection-cross-sell__wrapper');

    if ($(window).width() < 580) {
      initializeSlick();
    } else {
      if ($collectionCrossSellGrid.hasClass('slick-initialized')) {
        $collectionCrossSellGrid.slick('unslick');
      }
    }
  }

  // Initial check on page load
  checkWidth();

  // Check on window resize
  $(window).resize(function() {
    checkWidth();
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-slideshow"] && !Shopify.designMode) return;
  try {
    
  var $collectionGrid = $('.mobile_slider');
  $collectionGrid.slick({
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    lazyLoad: 'ondemand',
    pauseOnFocus: false,
    pauseOnHover: false
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  var $collectionGrid = $('.desktop_slider');
  $collectionGrid.slick({
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    lazyLoad: 'ondemand',
    pauseOnFocus: false,
    pauseOnHover: false
  });

  } catch(e) { console.error(e); }
})();
})();
